
        // Optional: Debug aktivieren via sessionStorage.setItem('debug_assistant', 'true')
        const DEBUG_MODE = sessionStorage.getItem('debug_assistant') === 'true';
        function debugLog(...args){ if (DEBUG_MODE) console.log('[LUCEO Demo]', ...args); }


        // =========================================================
        // Frontend-Session (Cookie) – stabil über Reloads
        // =========================================================
        function getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

        function setCookie(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + value + expires + "; path=/; SameSite=Lax;";
        }

        function generateSessionId() {
            var timestamp = new Date().getTime();
            var random = Math.random().toString(36).substring(2, 9);
            return 'session_' + timestamp + '_' + random;
        }

        function getOrCreateSessionId() {
            var sessionId = getCookie('chat_assistant_session');
            if (!sessionId) {
                sessionId = generateSessionId();
                setCookie('chat_assistant_session', sessionId, 7);
                console.log("🆕 Neue Session-ID erstellt:", sessionId);
            } else {
                debugLog("♻️ Session-ID wiederverwendet:", sessionId);
            }

            return sessionId;
        }

        // =========================================================
        // Chat Widget (wie bei der funktionierenden Demo):
        // - iFrame erst beim ersten Öffnen erzeugen
        // - iFrame src inklusive ?session=<id>
        // - src nicht ständig resetten
        // =========================================================
        let isChatOpen = false;
        let iframeCreated = false;

        // LUCEO Assistant (Proxy-Pfad)
        const ASSISTANT_URL = "https://business-vision-professional.de/zb-luceo/";

        function toggleChat() {
            const chatFrame = document.getElementById('chat-frame');
            const body = document.body;

            if (!iframeCreated) {
                const sessionId = getOrCreateSessionId();
                const savedLanguage = getCookie('chat_language');

                console.log("Assistant:" + ASSISTANT_URL);

                // URL mit Session und (falls vorhanden) gespeicherter Sprache
                let iframeSrc = ASSISTANT_URL + "?session=" + encodeURIComponent(sessionId);
                if (savedLanguage) {
                    iframeSrc += "&lang=" + encodeURIComponent(savedLanguage);
                    console.log("🌐 Gespeicherte Sprache gefunden:", savedLanguage);
                }

                const iframe = document.createElement('iframe');
                iframe.src = iframeSrc;
                iframe.loading = "lazy";
                iframe.title = "ZB LUCEO Produktberater";
                iframe.style.width = "100%";
                iframe.style.height = "100%";
                iframe.style.border = "none";

                // Wichtig: keine sandbox-Restriktionen, sofern dein Assistant same-origin sauber unterstützt
                // Wenn du sandbox zwingend brauchst, dann mind. allow-same-origin + allow-scripts:
                // iframe.setAttribute("sandbox", "allow-same-origin allow-scripts allow-forms allow-popups");

                chatFrame.classList.add('loading');
                iframe.addEventListener('load', () => {
                    chatFrame.classList.remove('loading');
                    debugLog("✅ iFrame geladen");
                });

                chatFrame.appendChild(iframe);
                iframeCreated = true;
                debugLog("✅ iFrame erstellt:", iframe.src);
            }

            isChatOpen = !isChatOpen;

            if (isChatOpen) {
                chatFrame.classList.add('active');
                if (window.innerWidth <= 500) body.classList.add('chat-open');
            } else {
                chatFrame.classList.remove('active', 'loading');
                body.classList.remove('chat-open');
            }
        }

        var widgetLanguage = null;

        // minimize-chat (aus iFrame)
        window.addEventListener('message', function(event) {
            const allowedOrigins = [
                'https://business-vision-professional.de',
                'http://localhost:3004'
            ];
            if (!allowedOrigins.includes(event.origin)) return;

            if (event.data === 'minimize-chat') {
                const chatFrame = document.getElementById('chat-frame');
                document.body.classList.remove('chat-open');
                chatFrame.classList.remove('active', 'loading');
                isChatOpen = false;
            }
            if(event.data && event.data.type === 'BVP_UPDATE_LANG'){
                widgetLanguage = event.data.lang;
                console.log('Sprache vom Widget:', widgetLanguage);
                setCookie('chat_language', event.data.lang, 7);

            }
        });

        // Responsive
        function handleResize() {
            const chatFrame = document.getElementById('chat-frame');
            if (window.innerWidth <= 500) {
                chatFrame.style.width = '100%';
                chatFrame.style.height = '100%';
                if (isChatOpen) document.body.classList.add('chat-open');
            } else {
                chatFrame.style.width = '400px';
                chatFrame.style.height = '600px';
                document.body.classList.remove('chat-open');
            }
        }
        window.addEventListener('resize', handleResize);
        handleResize();

        // Keyboard Navigation (Bubble)
        document.querySelector('.chat-bubble').addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleChat();
            }
        });

        // Badge entfernen
        setTimeout(() => {
            const badge = document.getElementById('newBadge');
            if (!badge) return;
            badge.classList.add('fade-out');
            setTimeout(() => badge.remove(), 650);
        }, 5000);

        // =========================================================
        // Pseudo Navigation: klick -> Chat schließen -> Hash setzen -> Reload
        // =========================================================
        function setActiveNav(key){
            document.querySelectorAll('.nav-sim a').forEach(a => {
                a.classList.toggle('active', a.getAttribute('data-nav') === key);
            });
        }

        document.querySelectorAll('.nav-sim a').forEach(a => {
            a.addEventListener('click', function(e){
                e.preventDefault();

                // Chat schließen (Simulation für Seitenwechsel)
                const chatFrame = document.getElementById('chat-frame');
                chatFrame.classList.remove('active', 'loading');
                document.body.classList.remove('chat-open');
                isChatOpen = false;

                const key = this.getAttribute('data-nav');
                setActiveNav(key);

                const targetHash = this.getAttribute('href') || '#start';
                window.location.hash = targetHash;

                // Echter Reload, um Seitenwechsel zu simulieren
                setTimeout(() => window.location.reload(), 60);
            });
        });

        window.addEventListener('DOMContentLoaded', () => {
            const hash = (window.location.hash || '#start').replace('#','') || 'start';
            setActiveNav(hash);
        });